/**
 * @author Jorge Casas
 * @creationDate 10/10/2025
 * @path src\components\dashboard\DashboardButtons.js
 */
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

class DashboardButtons extends Component {
  state = { hoverView: false, hoverAdd: false };

  chevron(hovered) {
    return (
      <i
        className="fa fa-angle-right"
        aria-hidden="true"
        style={{
          marginLeft: 10,
          fontSize: 18,
          transition: 'transform .25s ease, opacity .25s ease',
          transform: hovered ? 'translateX(4px)' : 'translateX(0)',
          opacity: hovered ? 1 : 0.85,
        }}
      />
    );
  }

  render() {
    const { subcompany, company, t } = this.props;
    const baseurl = `/companies/${company.id}/subcompanies/${subcompany.id}`;

    const cardStyle = (from, to, hovered, shadowRgb) => ({
      position: 'relative',
      display: 'block',
      width: '100%',
      color: '#fff',
      textDecoration: 'none',
      backgroundImage: `linear-gradient(135deg, ${from} 0%, ${to} 100%)`,
      border: 'none',
      borderRadius: 16,
      padding: '28px 24px',
      minHeight: 110,
      boxShadow: hovered
        ? `0 16px 40px rgba(${shadowRgb}, .28), 0 6px 16px rgba(0,0,0,.10)`
        : `0 10px 24px rgba(${shadowRgb}, .22), 0 3px 10px rgba(0,0,0,.08)`,
      transform: hovered ? 'translateY(-2px)' : 'translateY(0)',
      transition: 'all .25s ease',
      outline: 'none',
    });

    const watermarkIcon = (hovered) => ({
      position: 'absolute',
      left: 18,
      top: '50%',
      transform: 'translateY(-50%)',
      fontSize: 58,
      opacity: 0.18,
      transition: 'filter .25s ease',
      filter: hovered ? 'drop-shadow(0 0 8px rgba(255,255,255,.25))' : 'none',
    });

    const labelWrap = {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    };
    const labelStyle = {
      margin: 0,
      fontWeight: 700,
      fontSize: 18,
      letterSpacing: '.2px',
    };

    return (
      <div className="col-md-12">
        <div className="row pb-4 bg-default align-items-center dashboard-header-row">
          <div className="col-xl-6 mb-3 mb-xl-0">
            <div className="dashboard-header-hero">
              <div className="dashboard-header-icon">
                <i className="fa fa-line-chart" />
              </div>
              <div className="dashboard-header-copy">
                <h3 className="mb-1 dashboard-header-title">{t('dashboard.title')}</h3>
                <h5 className="dashboard-header-subtitle dashboard-header-subtitle--highlight">
                  {subcompany.name}
                </h5>
              </div>
            </div>
          </div>

          <div className="col-xl-3 col-lg-6 mb-3 mb-xl-0">
            <Form.Link
              to={`${baseurl}/assets`}
              className="d-block"
              style={cardStyle('#22d3ee', '#06b6d4', this.state.hoverView, '2,132,199')}
              onMouseEnter={() => this.setState({ hoverView: true })}
              onMouseLeave={() => this.setState({ hoverView: false })}
              onFocus={() => this.setState({ hoverView: true })}
              onBlur={() => this.setState({ hoverView: false })}
              aria-label={t('dashboard.showAssets')}
            >
              <span
                style={{
                  position: 'absolute',
                  inset: 0,
                  borderRadius: 16,
                  boxShadow: this.state.hoverView
                    ? '0 0 0 3px rgba(255,255,255,.35) inset'
                    : 'none',
                  pointerEvents: 'none',
                  transition: 'box-shadow .2s ease',
                }}
              />
              <i className="fa fa-qrcode" style={watermarkIcon(this.state.hoverView)} />
              <div style={labelWrap}>
                <p style={labelStyle}>{t('dashboard.showAssets')}</p>
                {this.chevron(this.state.hoverView)}
              </div>
            </Form.Link>
          </div>

          <div className="col-xl-3 col-lg-6">
            <Form.Link
              to={`${baseurl}/assets/add`}
              className="d-block"
              style={cardStyle('#34d399', '#10b981', this.state.hoverAdd, '16,185,129')}
              onMouseEnter={() => this.setState({ hoverAdd: true })}
              onMouseLeave={() => this.setState({ hoverAdd: false })}
              onFocus={() => this.setState({ hoverAdd: true })}
              onBlur={() => this.setState({ hoverAdd: false })}
              aria-label={t('dashboard.addAsset')}
            >
              <span
                style={{
                  position: 'absolute',
                  inset: 0,
                  borderRadius: 16,
                  boxShadow: this.state.hoverAdd ? '0 0 0 3px rgba(255,255,255,.35) inset' : 'none',
                  pointerEvents: 'none',
                  transition: 'box-shadow .2s ease',
                }}
              />
              <i className="fa fa-plus" style={watermarkIcon(this.state.hoverAdd)} />
              <div style={labelWrap}>
                <p style={labelStyle}>{t('dashboard.addAsset')}</p>
                {this.chevron(this.state.hoverAdd)}
              </div>
            </Form.Link>
          </div>
        </div>
      </div>
    );
  }
}

export default translate()(DashboardButtons);



// WEBPACK FOOTER //
// src/components/dashboard/DashboardButtons.js